// src/pages/Home.tsx
import { useEffect } from 'react';
import styles from './Home.module.css';
import { useLocales } from 'src/locales';

declare global {
  interface Window {
    CRISP_WEBSITE_ID?: string;
    $crisp?: any[];
  }
}

const Home = () => {

  const { translate: t } = useLocales();


  return (
    <div className={styles.homeContainer}>
      <header className={styles.homeHeader}>
        <h1>Bienvenido</h1>
        <p>
          Te conectamos con tu restaurante de confianza para que puedas pedir online de forma fácil y rápida,
          eligiendo entre recoger tu pedido (Take Away) o recibirlo cómodamente en casa (Delivery).
        </p>
      </header>
      <main className={styles.homeMain}>
        <div className={styles.homeContent}>
          <p>¿Tienes dudas o necesitas ayuda?</p>
          <p>Puedes escribirnos por mail: <strong>soporte@ambigumarket.com</strong>.</p>
          <p>O llamarnos al <strong>{t('home.formated-phone')}</strong>.</p>
          <p>Horario de atención: 12:00 a 16:00 &nbsp;20:00 a 24:00</p>
        </div>
        <div className={styles.crispLogoContainer}>
          <a href="mailto:soporte@ambigumarket.com" target="_parent">
            <img src="/img/mail.png" alt="Email Logo" />
          </a>
          <a href={"tel:+" + t('home.phone')}>
            <img src="/img/phone.png" alt="Phone Logo" />
          </a>
          <a href={"https://wa.me/" + t('home.phone')} target="_blank" rel="noopener noreferrer">
            <img src="/img/whats.png" alt="WhatsApp Logo" />
          </a>
        </div>
      </main>
      <footer className={styles.homeFooter}>
        <div className={styles.footerLinks}>
          <a href="https://ambigu.app/politica-de-privacidad.html" target="_blank">
            POLÍTICAS DE PRIVACIDAD
          </a>
          <a href="https://ambigu.app/terminos-y-condiciones.html" target="_blank">
            TÉRMINOS Y CONDICIONES
          </a>
        </div>
        <div className={styles.footerText}>
          {t('home.ambigu-europe')}
        </div>
      </footer>

      {/* Ícono flotante de WhatsApp */}
      <a
        href={"https://wa.me/34919496689"}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.whatsappFloatingButton}
      >
        <img src="/img/whats_green.png" alt="WhatsApp Flotante" />
      </a>
    </div>
  )
};

export default Home;